export default __webpack_public_path__ + "static/media/Team.6bbc20f7.svg";